// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as XemNgayRouteImport } from './routes/xem-ngay'
import { Route as VanKhiRouteImport } from './routes/van-khi'
import { Route as UserManualRouteImport } from './routes/user-manual'
import { Route as TuViDetailRouteImport } from './routes/tu-vi-detail'
import { Route as TuViChiTietRouteImport } from './routes/tu-vi-chi-tiet'
import { Route as TuViRouteImport } from './routes/tu-vi'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LaSoRouteImport } from './routes/la-so'
import { Route as KinhDichChiTietRouteImport } from './routes/kinh-dich-chi-tiet'
import { Route as IChingDetailRouteImport } from './routes/i-ching-detail'
import { Route as IChingRouteImport } from './routes/i-ching'
import { Route as HuongDanHoaHongRouteImport } from './routes/huong-dan-hoa-hong'
import { Route as HoTroRouteImport } from './routes/ho-tro'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DoanGioSinhRouteImport } from './routes/doan-gio-sinh'
import { Route as DatLaiMatKhauRouteImport } from './routes/dat-lai-mat-khau'
import { Route as CopyrightRouteImport } from './routes/copyright'
import { Route as ChuDeRouteImport } from './routes/chu-de'
import { Route as BatTuDetailRouteImport } from './routes/bat-tu-detail'
import { Route as BatTuChiTietRouteImport } from './routes/bat-tu-chi-tiet'
import { Route as BatTuRouteImport } from './routes/bat-tu'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RenderTokenRouteImport } from './routes/render.$token'
import { Route as QTokenRouteImport } from './routes/q.$token'
import { Route as AnhNenTokenRouteImport } from './routes/anh-nen.$token'
import { Route as LaSoTokenRouteImport } from './routes/la-so.$token'
import { Route as AuthenticatedTongHopRouteImport } from './routes/_authenticated.tong-hop'
import { Route as AuthenticatedThanhToanRouteImport } from './routes/_authenticated.thanh-toan'
import { Route as AuthenticatedSeDuyenRouteImport } from './routes/_authenticated.se-duyen'
import { Route as AuthenticatedOracleRouteImport } from './routes/_authenticated.oracle'
import { Route as AuthenticatedLichSuRouteImport } from './routes/_authenticated.lich-su'
import { Route as AuthenticatedKinhDichRouteImport } from './routes/_authenticated.kinh-dich'
import { Route as AuthenticatedHopThuRouteImport } from './routes/_authenticated.hop-thu'
import { Route as AuthenticatedGoiRouteImport } from './routes/_authenticated.goi'
import { Route as AuthenticatedGioiThieuRouteImport } from './routes/_authenticated.gioi-thieu'
import { Route as AuthenticatedDiemDanhRouteImport } from './routes/_authenticated.diem-danh'
import { Route as AuthenticatedCamNhanRouteImport } from './routes/_authenticated.cam-nhan'
import { Route as AuthenticatedBoiLiveRouteImport } from './routes/_authenticated.boi-live'
import { Route as AuthenticatedBoiChiTayRouteImport } from './routes/_authenticated.boi-chi-tay'
import { Route as AuthenticatedBienDongSoDuRouteImport } from './routes/_authenticated.bien-dong-so-du'
import { Route as AuthenticatedAnhNenRouteImport } from './routes/_authenticated.anh-nen'
import { Route as QTokenSlugRouteImport } from './routes/q_.$token.$slug'
import { Route as LaSoTokenSlugRouteImport } from './routes/la-so_.$token.$slug'
import { Route as AuthenticatedTongHopIndexRouteImport } from './routes/_authenticated.tong-hop.index'
import { Route as AuthenticatedTongHopVanKhiRouteImport } from './routes/_authenticated.tong-hop.van-khi'
import { Route as AuthenticatedTongHopLaBanRouteImport } from './routes/_authenticated.tong-hop.la-ban'
import { Route as AuthenticatedTongHopTopicRouteImport } from './routes/_authenticated.tong-hop.$topic'
import { Route as AuthenticatedSeDuyenIndexRouteImport } from './routes/_authenticated.se-duyen.index'
import { Route as AuthenticatedSeDuyenHandleRouteImport } from './routes/_authenticated.se-duyen.$handle'
import { Route as AuthenticatedBoiLiveIndexRouteImport } from './routes/_authenticated.boi-live.index'
import { Route as AuthenticatedBoiLiveSessionIdRouteImport } from './routes/_authenticated.boi-live.$sessionId'

const XemNgayRoute = XemNgayRouteImport.update({
            id: '/xem-ngay',path: '/xem-ngay',getParentRoute: () => rootRouteImport
          })
const VanKhiRoute = VanKhiRouteImport.update({
            id: '/van-khi',path: '/van-khi',getParentRoute: () => rootRouteImport
          })
const UserManualRoute = UserManualRouteImport.update({
            id: '/user-manual',path: '/user-manual',getParentRoute: () => rootRouteImport
          })
const TuViDetailRoute = TuViDetailRouteImport.update({
            id: '/tu-vi-detail',path: '/tu-vi-detail',getParentRoute: () => rootRouteImport
          })
const TuViChiTietRoute = TuViChiTietRouteImport.update({
            id: '/tu-vi-chi-tiet',path: '/tu-vi-chi-tiet',getParentRoute: () => rootRouteImport
          })
const TuViRoute = TuViRouteImport.update({
            id: '/tu-vi',path: '/tu-vi',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LaSoRoute = LaSoRouteImport.update({
            id: '/la-so',path: '/la-so',getParentRoute: () => rootRouteImport
          })
const KinhDichChiTietRoute = KinhDichChiTietRouteImport.update({
            id: '/kinh-dich-chi-tiet',path: '/kinh-dich-chi-tiet',getParentRoute: () => rootRouteImport
          })
const IChingDetailRoute = IChingDetailRouteImport.update({
            id: '/i-ching-detail',path: '/i-ching-detail',getParentRoute: () => rootRouteImport
          })
const IChingRoute = IChingRouteImport.update({
            id: '/i-ching',path: '/i-ching',getParentRoute: () => rootRouteImport
          })
const HuongDanHoaHongRoute = HuongDanHoaHongRouteImport.update({
            id: '/huong-dan-hoa-hong',path: '/huong-dan-hoa-hong',getParentRoute: () => rootRouteImport
          })
const HoTroRoute = HoTroRouteImport.update({
            id: '/ho-tro',path: '/ho-tro',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const DoanGioSinhRoute = DoanGioSinhRouteImport.update({
            id: '/doan-gio-sinh',path: '/doan-gio-sinh',getParentRoute: () => rootRouteImport
          })
const DatLaiMatKhauRoute = DatLaiMatKhauRouteImport.update({
            id: '/dat-lai-mat-khau',path: '/dat-lai-mat-khau',getParentRoute: () => rootRouteImport
          })
const CopyrightRoute = CopyrightRouteImport.update({
            id: '/copyright',path: '/copyright',getParentRoute: () => rootRouteImport
          })
const ChuDeRoute = ChuDeRouteImport.update({
            id: '/chu-de',path: '/chu-de',getParentRoute: () => rootRouteImport
          })
const BatTuDetailRoute = BatTuDetailRouteImport.update({
            id: '/bat-tu-detail',path: '/bat-tu-detail',getParentRoute: () => rootRouteImport
          })
const BatTuChiTietRoute = BatTuChiTietRouteImport.update({
            id: '/bat-tu-chi-tiet',path: '/bat-tu-chi-tiet',getParentRoute: () => rootRouteImport
          })
const BatTuRoute = BatTuRouteImport.update({
            id: '/bat-tu',path: '/bat-tu',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const RenderTokenRoute = RenderTokenRouteImport.update({
            id: '/render/$token',path: '/render/$token',getParentRoute: () => rootRouteImport
          })
const QTokenRoute = QTokenRouteImport.update({
            id: '/q/$token',path: '/q/$token',getParentRoute: () => rootRouteImport
          })
const AnhNenTokenRoute = AnhNenTokenRouteImport.update({
            id: '/anh-nen/$token',path: '/anh-nen/$token',getParentRoute: () => rootRouteImport
          })
const LaSoTokenRoute = LaSoTokenRouteImport.update({
            id: '/$token',path: '/$token',getParentRoute: () => LaSoRoute
          })
const AuthenticatedTongHopRoute = AuthenticatedTongHopRouteImport.update({
            id: '/tong-hop',path: '/tong-hop',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedThanhToanRoute = AuthenticatedThanhToanRouteImport.update({
            id: '/thanh-toan',path: '/thanh-toan',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSeDuyenRoute = AuthenticatedSeDuyenRouteImport.update({
            id: '/se-duyen',path: '/se-duyen',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedOracleRoute = AuthenticatedOracleRouteImport.update({
            id: '/oracle',path: '/oracle',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedLichSuRoute = AuthenticatedLichSuRouteImport.update({
            id: '/lich-su',path: '/lich-su',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedKinhDichRoute = AuthenticatedKinhDichRouteImport.update({
            id: '/kinh-dich',path: '/kinh-dich',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedHopThuRoute = AuthenticatedHopThuRouteImport.update({
            id: '/hop-thu',path: '/hop-thu',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedGoiRoute = AuthenticatedGoiRouteImport.update({
            id: '/goi',path: '/goi',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedGioiThieuRoute = AuthenticatedGioiThieuRouteImport.update({
            id: '/gioi-thieu',path: '/gioi-thieu',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDiemDanhRoute = AuthenticatedDiemDanhRouteImport.update({
            id: '/diem-danh',path: '/diem-danh',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCamNhanRoute = AuthenticatedCamNhanRouteImport.update({
            id: '/cam-nhan',path: '/cam-nhan',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedBoiLiveRoute = AuthenticatedBoiLiveRouteImport.update({
            id: '/boi-live',path: '/boi-live',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedBoiChiTayRoute = AuthenticatedBoiChiTayRouteImport.update({
            id: '/boi-chi-tay',path: '/boi-chi-tay',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedBienDongSoDuRoute = AuthenticatedBienDongSoDuRouteImport.update({
            id: '/bien-dong-so-du',path: '/bien-dong-so-du',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAnhNenRoute = AuthenticatedAnhNenRouteImport.update({
            id: '/anh-nen',path: '/anh-nen',getParentRoute: () => AuthenticatedRoute
          })
const QTokenSlugRoute = QTokenSlugRouteImport.update({
            id: '/q_/$token/$slug',path: '/q/$token/$slug',getParentRoute: () => rootRouteImport
          })
const LaSoTokenSlugRoute = LaSoTokenSlugRouteImport.update({
            id: '/la-so_/$token/$slug',path: '/la-so/$token/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedTongHopIndexRoute = AuthenticatedTongHopIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedTongHopRoute
          })
const AuthenticatedTongHopVanKhiRoute = AuthenticatedTongHopVanKhiRouteImport.update({
            id: '/van-khi',path: '/van-khi',getParentRoute: () => AuthenticatedTongHopRoute
          })
const AuthenticatedTongHopLaBanRoute = AuthenticatedTongHopLaBanRouteImport.update({
            id: '/la-ban',path: '/la-ban',getParentRoute: () => AuthenticatedTongHopRoute
          })
const AuthenticatedTongHopTopicRoute = AuthenticatedTongHopTopicRouteImport.update({
            id: '/$topic',path: '/$topic',getParentRoute: () => AuthenticatedTongHopRoute
          })
const AuthenticatedSeDuyenIndexRoute = AuthenticatedSeDuyenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedSeDuyenRoute
          })
const AuthenticatedSeDuyenHandleRoute = AuthenticatedSeDuyenHandleRouteImport.update({
            id: '/$handle',path: '/$handle',getParentRoute: () => AuthenticatedSeDuyenRoute
          })
const AuthenticatedBoiLiveIndexRoute = AuthenticatedBoiLiveIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedBoiLiveRoute
          })
const AuthenticatedBoiLiveSessionIdRoute = AuthenticatedBoiLiveSessionIdRouteImport.update({
            id: '/$sessionId',path: '/$sessionId',getParentRoute: () => AuthenticatedBoiLiveRoute
          })





const AuthenticatedBoiLiveRouteChildren = {
  AuthenticatedBoiLiveSessionIdRoute: AuthenticatedBoiLiveSessionIdRoute,AuthenticatedBoiLiveIndexRoute: AuthenticatedBoiLiveIndexRoute
}

const AuthenticatedBoiLiveRouteWithChildren = AuthenticatedBoiLiveRoute._addFileChildren(AuthenticatedBoiLiveRouteChildren)




const AuthenticatedSeDuyenRouteChildren = {
  AuthenticatedSeDuyenHandleRoute: AuthenticatedSeDuyenHandleRoute,AuthenticatedSeDuyenIndexRoute: AuthenticatedSeDuyenIndexRoute
}

const AuthenticatedSeDuyenRouteWithChildren = AuthenticatedSeDuyenRoute._addFileChildren(AuthenticatedSeDuyenRouteChildren)




const AuthenticatedTongHopRouteChildren = {
  AuthenticatedTongHopTopicRoute: AuthenticatedTongHopTopicRoute,AuthenticatedTongHopLaBanRoute: AuthenticatedTongHopLaBanRoute,AuthenticatedTongHopVanKhiRoute: AuthenticatedTongHopVanKhiRoute,AuthenticatedTongHopIndexRoute: AuthenticatedTongHopIndexRoute
}

const AuthenticatedTongHopRouteWithChildren = AuthenticatedTongHopRoute._addFileChildren(AuthenticatedTongHopRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAnhNenRoute: AuthenticatedAnhNenRoute,AuthenticatedBienDongSoDuRoute: AuthenticatedBienDongSoDuRoute,AuthenticatedBoiChiTayRoute: AuthenticatedBoiChiTayRoute,AuthenticatedBoiLiveRoute: AuthenticatedBoiLiveRouteWithChildren,AuthenticatedCamNhanRoute: AuthenticatedCamNhanRoute,AuthenticatedDiemDanhRoute: AuthenticatedDiemDanhRoute,AuthenticatedGioiThieuRoute: AuthenticatedGioiThieuRoute,AuthenticatedGoiRoute: AuthenticatedGoiRoute,AuthenticatedHopThuRoute: AuthenticatedHopThuRoute,AuthenticatedKinhDichRoute: AuthenticatedKinhDichRoute,AuthenticatedLichSuRoute: AuthenticatedLichSuRoute,AuthenticatedOracleRoute: AuthenticatedOracleRoute,AuthenticatedSeDuyenRoute: AuthenticatedSeDuyenRouteWithChildren,AuthenticatedThanhToanRoute: AuthenticatedThanhToanRoute,AuthenticatedTongHopRoute: AuthenticatedTongHopRouteWithChildren
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const LaSoRouteChildren = {
  LaSoTokenRoute: LaSoTokenRoute
}

const LaSoRouteWithChildren = LaSoRoute._addFileChildren(LaSoRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,BatTuRoute: BatTuRoute,BatTuChiTietRoute: BatTuChiTietRoute,BatTuDetailRoute: BatTuDetailRoute,ChuDeRoute: ChuDeRoute,CopyrightRoute: CopyrightRoute,DatLaiMatKhauRoute: DatLaiMatKhauRoute,DoanGioSinhRoute: DoanGioSinhRoute,FaqRoute: FaqRoute,HoTroRoute: HoTroRoute,HuongDanHoaHongRoute: HuongDanHoaHongRoute,IChingRoute: IChingRoute,IChingDetailRoute: IChingDetailRoute,KinhDichChiTietRoute: KinhDichChiTietRoute,LaSoRoute: LaSoRouteWithChildren,LoginRoute: LoginRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,TuViRoute: TuViRoute,TuViChiTietRoute: TuViChiTietRoute,TuViDetailRoute: TuViDetailRoute,UserManualRoute: UserManualRoute,VanKhiRoute: VanKhiRoute,XemNgayRoute: XemNgayRoute,AnhNenTokenRoute: AnhNenTokenRoute,QTokenRoute: QTokenRoute,RenderTokenRoute: RenderTokenRoute,LaSoTokenSlugRoute: LaSoTokenSlugRoute,QTokenSlugRoute: QTokenSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)